import { render, staticRenderFns } from "./clickUpload.vue?vue&type=template&id=3ee309aa&"
import script from "./clickUpload.vue?vue&type=script&lang=js&"
export * from "./clickUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zhishengluo/opp-scratch/scratch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ee309aa')) {
      api.createRecord('3ee309aa', component.options)
    } else {
      api.reload('3ee309aa', component.options)
    }
    module.hot.accept("./clickUpload.vue?vue&type=template&id=3ee309aa&", function () {
      api.rerender('3ee309aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/upload/clickUpload.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/upload/clickUpload.vue
// module id = I9oc
// module chunks = 0